import { Icon } from "@rally/ui-kit";
import { conversationGlyph } from "./conversation-glyph.ts";

export function ConversationIcon({
  icon,
  title,
  size,
  color,
}: {
  icon: string | null;
  title: string | null;
  size: number;
  color: "accent" | "text.tertiary";
}) {
  return <Icon name={conversationGlyph(icon, title)} size={size} color={color} />;
}
